<template>

  <v-select 
    multiple 
    :value="selected"
    @input="change"
    :options="options"
    :placeholder="placeholder">
    </v-select>

</template>

<script>
export default {
  name: 'SelectMultipleUser',
  props: {
    'value': {
      type: Array,
      default: []
    },
    'placeholder': {
      type: String,
      default: null
    },
    'active': {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      'members': []
    }
  },
  computed: {
    valueIds () {
      return this.value.map((val) => {
        return val._id || val
      })
    },
    options () {
      return this.members.map((val) => {
        return {
          label: val.user_id.name,
          value: val.user_id._id
        }
      })
    },
    selected () {
      return this.valueIds.map(id => {
        return this.options.find(v => v.value === id)
      }).filter(v => v)
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getMembers', { sort: 'name', limit: 1000, active: this.active, consider_ids: this.valueIds })
      .then((result) => {
        this.members = result.docs
      })
    },
    change (val) {
      const values = val.map((val) => {
        return val.value
      })

      if (this.options.length && JSON.stringify(values) !== JSON.stringify(this.valueIds)) {
        this.$emit('input', values)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectMultipleUser.vue